<template>
  <div class="box">
    <div class="shadow"></div>
    <div class="content">
      <p>请填写收货信息</p>
      <input type="text" class="Input mt" placeholder="请输入你的姓名" v-model="name">
      <input
        type="number"
        class="Input mt1"
        placeholder="请输入联系手机"
        maxlength="11"
        v-model="phone"
      >
      <textarea class="mt1 text" placeholder="请输入邮寄地址" v-model="address"></textarea>
      <button class="btn0" style="margin-top:0.35rem" @click="handleSubmit">确定</button>
      <div class="cancel" @click="()=>{this.$emit('cancle')}"></div>
    </div>
    <Bingo
      v-if="open"
      :title="title"
      @cancle="(obj)=>{
      if(obj){
        this.$emit('cancle')
      }
      this.open=!this.open
      }"
    />
  </div>
</template>

<script>
import Bingo from "../common/Bingo";
import { fill_address, my_address } from "../../utils/config";
export default {
  props: {
    drawId: {
      type: Number,
      default: 0,
      required: true
    }
  },
  components: {
    Bingo
  },
  mounted() {
    this.$axios({
      withCredentials: true,
      crossDomain: true,
      method: "get",
      url: my_address,
      params:{
        prizeType:'SW'
      }
    }).then(res => {
      let { data } = res.data;
      let address=data.address.split('/')
      this.name=address[0];
      this.phone=address[1];
      this.address=address[2];
    });
  },
  data: () => ({
    open: false,
    title: "",
    name: "",
    phone: "",
    address: ""
  }),
  methods: {
    handleSubmit() {
      if (!this.name || !this.phone || !this.address) {
        this.title = "请填写完整信息";
        this.open = true;
        return;
      }
      if (
        this.phone ==
        /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/
      ) {
        this.title = "请填写正确的手机号";
        this.open = true;
        return;
      }
      this.$axios({
        withCredentials: true,
        crossDomain: true,
        method: "get",
        url: fill_address,
        params: {
          drawId: this.drawId,
          address:`${this.name}/${this.phone}/${this.address}`
        }
      }).then(res => {
        let { data } = res;
        if (data.code == 0) {
          this.title = data;
          this.open = true;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
}
.shadow {
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.5;
}
.content {
  position: absolute;
  border-radius: 10px;
  left: 50%;
  top: 29%;
  transform: translateX(-50%);
  width: 660px;
  text-align: center;
  font-size: 30px;
  background: #fff;
  z-index: 99999;
  padding: 35px 35px 0;
  .Input {
    width: 100%;
    height: 70px;
    border: 1px solid #c6c6c6;
    border-radius: 10px;
    font-size: 20px;
    padding-left: 35px;
  }
  .mt {
    margin-top: 40px;
  }
  .mt1 {
    margin-top: 10px;
  }
  .btn0 {
    width: 100%;
    height: 70px;
    background: #d753f0;
    text-align: center;
    line-height: 70px;
    font-size: 24px;
    color: #fff;
    border-radius: 10px;
  }
  .text {
    font-size: 20px;
    padding-left: 35px;
    padding-top: 25px;
    width: 100%;
    border: 1px solid #c6c6c6;
    border-radius: 10px;
    height: 176px;
    outline: none;
  }
}
.cancel {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  bottom: -100px;
  height: 48px;
  width: 48px;
  background: url("../assets/guanbi.png") no-repeat;
  background-size: 100% 100%;
}
</style>
